"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var asap_1 = require("rxjs/scheduler/asap");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/scan");
require("rxjs/add/operator/retryWhen");
require("rxjs/add/operator/share");
require("rxjs/add/operator/publish");
require("rxjs/add/operator/publishReplay");
require("rxjs/add/operator/do");
require("rxjs/add/operator/catch");
require("rxjs/add/observable/from");
require("rxjs/add/observable/of");
require("rxjs/add/observable/merge");
require("rxjs/add/observable/timer");
require("rxjs/add/operator/onErrorResumeNext");
var CommandHandlerError = (function (_super) {
    __extends(CommandHandlerError, _super);
    function CommandHandlerError(message, handler, command) {
        var _this = _super.call(this, message) || this;
        _this.handler = handler;
        _this.command = command;
        return _this;
    }
    return CommandHandlerError;
}(Error));
var CommandQueue = (function () {
    function CommandQueue() {
        this.handlers = [];
        this.privateBus = new Subject_1.Subject();
    }
    CommandQueue.prototype.getEventSource = function () {
        return this.privateBus;
    };
    CommandQueue.prototype.subscribe = function (handler) {
        console.log('subscribed handler', handler.constructor.name);
        this.handlers.push(handler);
    };
    CommandQueue.prototype.queue = function (command) {
        var _this = this;
        console.log('queue command', command);
        var observables = this.handlers.map(function (handler) { return _this.pushToHandler(handler, command); });
        var queuedCommand = Observable_1.Observable.merge.apply(Observable_1.Observable, observables.concat([asap_1.asap])).share();
        var subscription = [];
        var eventBusAdapter = {
            next: function (event) {
                console.log('publish to event bus', event);
                _this.privateBus.next(event);
            },
            error: function (error) {
                console.error('error in queue', error, command);
            },
            complete: function () {
                console.log('command completed', command);
                subscription[0].unsubscribe();
            }
        };
        subscription.push(queuedCommand.subscribe(eventBusAdapter));
        return queuedCommand;
    };
    CommandQueue.prototype.pushToHandler = function (handler, command) {
        var handlerResult;
        try {
            handlerResult = Observable_1.Observable.from(handler(command), asap_1.asap);
        }
        catch (e) {
            console.error(e);
            handlerResult = Observable_1.Observable.throw(e);
        }
        return handlerResult;
    };
    return CommandQueue;
}());
exports.CommandQueue = CommandQueue;
var ProcessManagerContainer = (function () {
    function ProcessManagerContainer() {
        var _this = this;
        this.queue = function (command) {
            return _this.commandQueue.queue(command);
        };
    }
    ProcessManagerContainer.prototype.async = function (c) {
        var _this = this;
        var queueResult = c.then(function (cmd) {
            return _this.queue(cmd);
        });
        return Observable_1.Observable.from(queueResult, asap_1.asap).share();
    };
    ProcessManagerContainer.prototype.simple = function (f) {
        var _this = this;
        return function () { return _this.queue(f()); };
    };
    return ProcessManagerContainer;
}());
exports.ProcessManagerContainer = ProcessManagerContainer;
var CommandLayer = (function () {
    function CommandLayer(actions, handlers, queue) {
        var _this = this;
        this.actions = actions;
        this.handlers = handlers;
        this.queue = queue;
        this.actions.commandQueue = this.queue;
        this.handlers.map(function (handler) { return _this.queue.subscribe(handler); });
    }
    CommandLayer.prototype.dispose = function () {
        this.handlers.forEach(function (d) { return d; });
    };
    return CommandLayer;
}());
exports.CommandLayer = CommandLayer;
//# sourceMappingURL=command.js.map